module.exports = __webpack_public_path__ + "static/media/logo186.ef880115.png";